import WidgetRegistrationCounts from '../Widgets/WidgetRegistrationCounts';
import WidgetSalesByShow from '../Widgets/WidgetSalesByShow';
import WidgetMailCodeCounts from '../Widgets/WidgetMailCodeCounts';
import WidgetCallSheets from '../Widgets/WidgetCallSheets';
import WidgetRepDocumentLibrary from '../Widgets/WidgetRepDocumentLibrary';
import WidgetRepEmailTemplateLibrary from '../Widgets/WidgetRepEmailTemplateLibrary';
import WidgetRegistrationScorecard from '../Widgets/WidgetRegistrationScorecard';
import WidgetFEPMetricsByShow from '../Widgets/WidgetFEPMetricsByShow';

export const componentMap = [
    { "WidgetName": "RegistrationCounts", "WidgetTitle": "Registration Counts", "WidgetComponent": <WidgetRegistrationCounts /> },
    { "WidgetName": "SalesByShow", "WidgetTitle": "Sales By Show", "WidgetComponent": <WidgetSalesByShow /> },
    { "WidgetName": "MailCodeCounts", "WidgetTitle": "Mail Code Counts", "WidgetComponent": <WidgetMailCodeCounts /> },
    { "WidgetName": "CallSheets", "WidgetTitle": "Call Sheets", "WidgetComponent": <WidgetCallSheets /> },
    { "WidgetName": "RepDocumentLibrary", "WidgetTitle": "Rep Document Library", "WidgetComponent": <WidgetRepDocumentLibrary /> },
    { "WidgetName": "RepEmailTemplateLibrary", "WidgetTitle": "Rep Email Template Library", "WidgetComponent": <WidgetRepEmailTemplateLibrary /> },
    { "WidgetName": "RegistrationScorecard", "WidgetTitle": "Registration Scorecard", "WidgetComponent": <WidgetRegistrationScorecard /> },
    { "WidgetName": "FEPMetricsByShow", "WidgetTitle": "FEP Metrics By Show", "WidgetComponent": <WidgetFEPMetricsByShow /> }
];
